<template>
  <!-- Modal: Changing Stores -->
  <div :class="modal ? 'modal is-active' : 'modal'">
    <div class="modal-background"></div>
    <div class="modal-card is-small">
      <header class="modal-card-head">
        <button @click="closeModal()" class="delete" aria-label="close"></button>
        <p class="modal-card-title">{{ changeStoreHeading }}</p>
      </header>
      <section class="modal-card-body has-text-centered ph20">
        <img class="has-text-centered mt15 mb20" src="@/assets/img/icon-bucket.png" alt="Empty" />
        <p class="has-text-centered is-size-14 modal-text" v-if="vg_cartItems.length > 0">
          Your cart already has items from a
          <br />different
          store. Would you like to empty
          <br />your cart and start a new one?
        </p>
      </section>
      <footer class="modal-card-foot is-flex-column">
        <button
          @click.prevent="startNewCart()"
          class="button is-large is-primary is-full-width mr0 mb20"
        >Start a New Cart</button>
        <a href="#" @click.prevent="closeModal()" class="has-text-centered">Cancel</a>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { isEmpty } from 'lodash';

export default {
  name: "ProductDetailChangeStoreNotice",
  data() {
    return {
      modal: false
    };
  },

  mounted() {
    bus.$on("show-modal-change-store-notice", payload => {
      this.modal = payload;
    });
  },

  beforeDestroy() {
    bus.$off('show-modal-change-store-notice');
  },

  computed: {
    ...mapGetters({
      vg_cartItems: "cart/cartItems",
      vg_selectedLocation: "location/selected"
    }),
    changeStoreHeading() {
      if(_.isEmpty(this.vg_selectedLocation)) {
         return 'Select store';
      }
      return 'Changing Stores'
    },
  },

  methods: {
    closeModal() {
      this.modal = false;
    },
    /**
     * Remove old card data and start new
     */
    startNewCart() {
      this.modal = false;
      bus.$emit("show-modal-select-store", true);
    },
    ...mapActions({
    })
    
  }
};
</script>